<template>
  <div class="animated fadeIn list-of-tranbank">
    <b-row>
      <b-col offset-lg="1" lg="10">
        <b-card>
          <div slot="header">
            {{$route.meta.label}}
            <div class="card-header-actions">
              <button class="btn btn-primary mr-1" @click="exportxls()">
                <i class="fa fa-file-excel-o"></i>
                Export
              </button>
              <button class="btn btn-danger mr-1" @click="close()">
                <i class="fa fa-close"></i> Close
              </button>
            </div>
          </div>
          <b-row>
            <b-col lg="4">
              <b-input-group>
                <b-input-group-prepend>
                  <span class="pt-2 mr-2">Tahun</span>
                </b-input-group-prepend>
                <b-form-input v-model="model.tahun" type="number" :state="!$v.model.tahun.$error"></b-form-input>
                <b-input-group-prepend>
                  <span class="pt-2 ml-2 mr-2">Jml. Ranking</span>
                </b-input-group-prepend>
                <b-form-select v-model="model.peringkat" :options="rankOptions"></b-form-select>
              </b-input-group>
            </b-col>
            <b-col lg="2">
              <b-button class="btn btn-success" @click="proses()">
                <i class="fa fa-play"></i> Process
              </b-button>
            </b-col>
          </b-row>
          <b-card no-body>
            <b-table
              class="mb-0"
              ref="table"
              sticky-header="600px"
              outlined
              responsive
              striped
              hover
              style="font-size:smaller;"
              :items="tblLcy.items"
              :fields="tblLcy.fields"
              :current-page="tblLcy.page"
              :per-page="tblLcy.limit"
              :sort-by.sync="tblLcy.sortBy"
              :sort-desc.sync="tblLcy.sortDesc"
              :filter="filter"
              :filterIncludedFields="filterOn"
              show-empty
            >
              <template v-slot:cell(seq)="data">{{ data.index + 1 }}</template>
              <template
                v-slot:cell(OrderDate)="data"
              >{{ data.item.OrderDate | moment('YYYY-MM-DD')}}</template>
              <template v-slot:cell(custinfo)="data">{{ data.item.custinfo}}</template>
               <template v-slot:cell(numOfTrx)="data">
                  <a
                    href="javascript:void(0)"
                    @click.stop="getDetailOrdered(data.item)"
                  >{{data.item.numOfTrx | numFormat}}</a>
               </template>
              
              <template v-slot:cell(sumttlnetto)="data">{{ data.item.sumttlnetto | numFormat }}</template>
              <template v-slot:empty="scope">
                <h4>{{ scope.emptyText }}</h4>
              </template>
              <template v-slot:emptyfiltered="scope">
                <h4>{{ scope.emptyFilteredText }}</h4>
              </template>
            </b-table>
            <b-row class="mt-2">
              <b-col cols="4">
                <div>Total Omset : {{uanguser}} {{tblLcy.omsettotal | numFormat}}</div>
              </b-col>
              <b-col cols="8">
                <b-row>
                  <b-col cols="6" style="text-align:center">
                    <div>
                      Showing {{(tblLcy.page - 1) * tblLcy.limit + 1}}
                      to
                      <span
                        v-if="((tblLcy.page * tblLcy.limit)>tblLcy.total)"
                      >{{tblLcy.total}}</span>
                      <span v-else>{{tblLcy.page * tblLcy.limit}}</span>
                      of {{tblLcy.total}} entries,
                      <span
                        class="ml-3 mr-1"
                      >limit per page :</span>
                    <input type="number" style="width:80px;" v-model="tblLcy.limit" v-b-tooltip.hover :title="`${tblLcy.limit} records`" />
                    </div>
                  </b-col>
                  <b-col cols="6">
                    <b-pagination
                      align="right"
                      :total-rows="tblLcy.total"
                      :per-page="tblLcy.limit"
                      v-model="tblLcy.page"
                    ></b-pagination>
                  </b-col>
                </b-row>
              </b-col>
            </b-row>


          </b-card>
        </b-card>
      </b-col>
    </b-row>

    <loading :active.sync="isLoading" :height="128" :width="128" color="#4b8cf4"></loading>
    <b-modal v-model="showReport" size="xl" scrollable title="Preview as PDF" ok-only>
      <iframe :src="reportUrl" frameborder="0"></iframe>
    </b-modal>
    <b-modal
      v-model="showDetailOrder"
      size="lg"
      header-bg-variant="primary"
      title="Show detail ordered"
      ok-only
    >
      <lku-sales-order :tahun="model.tahun" :customer_id="model.customer_id" :tblBordered="true"></lku-sales-order>
    </b-modal>
  </div>
</template>


<script>
import moment from "moment";
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";
import toastr from "mini-toastr";
import { validationMixin } from "vuelidate";
import { required } from "vuelidate/lib/validators";
toastr.init();

import salesreport from "../../apis/salesReport";
// import lkuAgency from "../lookup/lkuAgency";
import lkuSalesOrder from "../lookup/lkuSalesOrder";


export default {
  mixins: [validationMixin],
  validations: {
    model: {
      tahun: { required }
      // tgl1: { required },
      // tgl2: { required }
    }
  },
  data() {
    return {
      horizontal: true,
      isLoading: false,
      showReport: false,
      showDetailOrder: false,
      reportUrl: null,
      model: {
        tgl1: "",
        tgl2: "",
        customer_group: "",
        peringkat: 10,
        tahun: moment(this.$store.state.user.tglaktif).format("YYYY")
      },
      filterShow: "Show",
      uanguser: this.$store.state.user.matauang,
      rankOptions: [
        { value: 10, text: "Top 10" },
        { value: 20, text: "Top 20" },
        { value: 30, text: "Top 30" },
        { value: 40, text: "Top 40" },
        { value: 50, text: "Top 50" }
      ],
      rptLines: [],
      subtotal: {},
      tblLcy: {
        page: 1,
        limit: 15,
        total: 0,
        sortBy: null,
        sortDesc: false,
        fields: [
          {
            key: "seq",
            label: "#",
            thStyle: "width:50px",
            thClass: "text-center",
            tdClass: "text-center"
          },
          {
            key: "CustCode",
            label: "Customer Code",
            thClass: "text-center",
            sortable: true
          },
          {
            key: "CustName",
            label: "Customer Name",
            thClass: "text-center",
            sortable: true
          },
          {
            key: "numOfTrx",
            label: "Number Of Trx.",
            thClass: "text-center",
            tdClass: "text-right",
            sortable: true
          },
          {
            key: "matauang",
            label: "$,¥",
            thClass: "text-center",
            tdClass: "text-right",
            sortable: true
          },
          {
            key: "sumttlnetto",
            label: "Total Sales",
            thClass: "text-center",
            tdClass: "text-right",
            sortable: true
          },

          {
            key: "OrderDate",
            label: "Last Order Date",
            thClass: "text-center",
            tdClass: "text-right",
            sortable: true
          }
        ]
      },
      filter: null,
      filterOn: [],
      cust_info: null,
      customer_info: null
    };
  },
  components: { Loading,lkuSalesOrder },
  watch: {
    'model.customer_group': function(newVal) {
      this.tblLcy.items=[];
      this.$forceUpdate();
    }            
  },
  created: async function() {
    const { name } = this.$route;
    if (name === "sales.topsalesbycustomer") {
      this.model.customer_group = "";
    } else if (name === "sales.topsalesbyagency") {
      this.model.customer_group = "AGENCY";
    } else if (name === "sales.topsalesbyagency") {
      this.model.customer_group = "DIRECT";
    }
    // this.$watch('model.customer_group', function(newVal) {
    //   this.tblLcy.items=[];
    //   this.$forceUpdate();
    // });            

  },
  methods: {
    getData: async function(ctx) {
      this.isLoading = true;
      this.model.sortDir = this.model.sortDesc ? "desc" : "asc";
      const result = await salesreport.topSalesOrderByCustomer(this.model);
      this.isLoading = false;
      this.tblLcy.items=result;
      this.tblLcy.total=result.length;
      this.tblLcy.omsettotal = result.reduce((a, b) => a + b.sumttlnetto, 0);
      // return result;
    },
    proses() {
      this.getData();
    },
    toggleShowDetailOrder() {
      this.showDetailOrder = !this.showDetailOrder;
    },
    getDetailOrdered: async function(row) {
      if (row.numOfTrx > 0) {
        this.toggleShowDetailOrder();
        this.detailOrder = row;
      }
    },
    exportxls: async function() {
      if (this.invalidFilter) {
        toastr.error("Please fill the form correctly.");
      } else {
        this.isLoading = true;
        try {
          await salesreport.topSalesOrderByCstExport2Excell(this.model);
          this.isLoading = false;
        } catch (error) {
          this.isLoading = false;
          if (error.message) {
            toastr.error(error.message);
          } else {
            toastr.error(JSON.stringify(error));
          }
        }
      }
    },
    close() {
      router.push({name: "sales.home"});
    }
  }
};
</script>
